import { Phone, MessageCircle } from "lucide-react";

const TONES = { green: "border-l-[#2E9E6B]", coral: "border-l-[#E05C3A]", amber: "border-l-[#E0A43A]", ink: "border-l-[#0D3B2B]", grey: "border-l-[#C9D3CC]" };

export const Panel = ({ title, sub, action, children, className = "", testid }) => (
  <section className={`ks-rise rounded-2xl border border-[#E3E6DD] bg-white ${className}`} data-testid={testid}>
    {title && (
      <header className="flex flex-wrap items-center justify-between gap-3 border-b border-[#EEF0E9] px-5 py-4">
        <div><h3 className="ks-serif text-lg text-[#0D3B2B]">{title}</h3>{sub && <p className="text-xs text-[#6B7F74]">{sub}</p>}</div>
        {action}
      </header>
    )}
    <div className="p-5">{children}</div>
  </section>
);

export const Stat = ({ label, value, hint, tone = "grey", onClick, testid }) => {
  const C = onClick ? "button" : "div";
  return (
    <C onClick={onClick} data-testid={testid}
      className={`group rounded-xl border border-[#E3E6DD] border-l-4 ${TONES[tone]} bg-white p-4 text-left transition-[transform,box-shadow] duration-200 ${onClick ? "hover:-translate-y-0.5 hover:shadow-[0_8px_24px_-12px_rgba(13,59,43,.35)]" : ""}`}>
      <p className="ks-serif text-3xl leading-none text-[#0D3B2B]">{value}</p>
      <p className="mt-2 text-sm font-bold text-[#0D3B2B]">{label}</p>
      {hint && <p className="text-xs text-[#6B7F74]">{hint}</p>}
    </C>
  );
};

const digits = (m) => (m || "").replace(/\D/g, "").slice(-10);

export const ContactButtons = ({ mobile, testid = "contact" }) => (mobile ? (
  <div className="flex gap-2">
    <a href={`tel:+91${digits(mobile)}`} data-testid={`${testid}-call`} className="inline-flex h-9 items-center gap-1.5 rounded-full border border-[#0D3B2B] px-3 text-xs font-bold text-[#0D3B2B] transition-colors hover:bg-[#0D3B2B] hover:text-white"><Phone className="h-3.5 w-3.5" />Call</a>
    <a href={`https://wa.me/91${digits(mobile)}`} target="_blank" rel="noreferrer" data-testid={`${testid}-whatsapp`} className="inline-flex h-9 items-center gap-1.5 rounded-full bg-[#25D366] px-3 text-xs font-bold text-white transition-opacity hover:opacity-90"><MessageCircle className="h-3.5 w-3.5" />WhatsApp</a>
  </div>
) : null);

export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;

export const Empty = ({ children }) => <p className="rounded-xl bg-[#F7F5EF] p-6 text-center text-sm text-[#6B7F74]">{children}</p>;
